import { useContext } from 'react';

import ExternalFooter from '../ExternalFooter/ExternalFooter';
import { UserContext } from '../../App';

import logo from './monitor-monk-logo.png';

import styles from './Footer.module.scss';

const Footer = () => {
  const { user } = useContext(UserContext);

  return (
    <>
      {user ? null : <ExternalFooter />}
      <footer className={styles.footer}>
        <div className="container">
          <img src={logo} alt="MonitorMonk" />
          <div>Copyright MonitorMonk. All Rights Reserved</div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
